import React from 'react';
import { ValetIcon } from './icons/ValetIcon';
import { formatSidebarCount } from '../utils/curatedPlaylistCounts';
import { curatedByMaestroLabel } from '../i18n/navCuratedLabels';
import { buildMyPlaylistLabel } from '../i18n/buildMyPlaylistLabel';

const SectionLabel = ({ children, sectionId, dimmed = false, compact = false }) => (
  <div
    data-sidebar-id={sectionId || undefined}
    className={`px-3 uppercase flex items-center gap-1.5 ${compact ? 'mt-3 mb-1' : 'mt-5 mb-2'}`}
    style={{
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: '0.08em',
      color: 'var(--sidebar-text-sec)',
      opacity: dimmed ? 0.65 : 1,
    }}
  >
    <span className="flex-1 min-w-0 truncate">{children}</span>
  </div>
);

export default function SidebarPlaylistNavItems({
  NavButton,
  t,
  lang,
  activeView,
  curatedCounts,
  userPlaylistsLoaded,
  userPlaylistsCount,
  onNavigateSmartPlaylists,
  onNavigateMyPlaylists,
  onNavigateAudiophilePlaylists,
  onNavigateGenrePlaylists,
  onNavigateMoodPlaylists,
  onNavigateSeasonPlaylists,
}) {
  return (
    <>
      <NavButton
        active={activeView === 'smart_playlists' || activeView === 'valet_for_you'}
        onClick={() => onNavigateSmartPlaylists?.()}
        itemId="valet_for_you"
        icon={<span className="text-amber-400"><ValetIcon size={18} /></span>}
      >
        {buildMyPlaylistLabel(lang)}
      </NavButton>
      <NavButton
        active={activeView === 'my_playlists' || activeView === 'favorites' || activeView === 'favorites_playlists'}
        onClick={() => onNavigateMyPlaylists?.()}
        itemId="my_playlists"
        badge={userPlaylistsLoaded ? formatSidebarCount(userPlaylistsCount ?? 0) : undefined}
        icon={
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18V5l12-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="18" cy="16" r="3" />
          </svg>
        }
      >
        {t('nav.my_playlists')}
      </NavButton>
      <SectionLabel dimmed compact sectionId="curated_by_maestro">
        {curatedByMaestroLabel(lang)}
      </SectionLabel>
      <NavButton
        active={activeView === 'audiophile_playlists'}
        onClick={() => onNavigateAudiophilePlaylists?.()}
        itemId="audiophile_playlists"
        badge={formatSidebarCount(curatedCounts?.audiophile)}
        icon={<span className="text-base">🎧</span>}
      >
        {t('nav.audiophile')}
      </NavButton>
      <NavButton
        active={activeView === 'genre_playlists'}
        onClick={() => onNavigateGenrePlaylists?.()}
        itemId="genre_playlists"
        badge={formatSidebarCount(curatedCounts?.styles)}
        icon={<span className="text-base">🏷️</span>}
      >
        {t('nav.genre_playlists')}
      </NavButton>
      <NavButton
        active={activeView === 'mood_playlists'}
        onClick={() => onNavigateMoodPlaylists?.()}
        itemId="mood_playlists"
        badge={formatSidebarCount(curatedCounts?.moods)}
        icon={<span className="text-base">🌙</span>}
      >
        {t('nav.mood_playlists')}
      </NavButton>
      <NavButton
        active={activeView === 'season_playlists'}
        onClick={() => onNavigateSeasonPlaylists?.()}
        itemId="season_playlists"
        badge={formatSidebarCount(curatedCounts?.seasons)}
        icon={<span className="text-base">🍂</span>}
      >
        {t('nav.season_playlists')}
      </NavButton>
    </>
  );
}
